<script>
// assets/project/src/components/FprkProject.vue

import SaveInfo from "./Base/SaveInfo";
import axios from "axios";
import BaseInput from "./Base/BaseInput3";
import BaseTextarea from "./Base/BaseTextarea";
import {Spin, message} from 'ant-design-vue';
import TinymceEditor from "./Base/TinymceEditor3";
import BasePdfUploader from "@/components/Base/BasePdfUploader.vue";
import RadioInput from "@/components/Base/RadioInput.vue";
import BaseLocationOnlyCityRegion from "@/components/Base/BaseLocationOnlyCityRegion.vue";
import BaseLocationOnlyCountry from "@/components/Base/BaseLocationOnlyCountry.vue";
import BaseLocationCountryRegionCity from "@/components/Base/BaseLocationCountryRegionCity.vue";
import {Field, Form} from 'vee-validate';
import Json from '@/services/json';
import BaseChoiseSelect from "@/components/Base/BaseChoiseSelect.vue";

//Схема для вкладки Организация/ИП
const data_schema = {
	'organization_name': '',
	'organization_name_short': '',
	'ogrn': '',
	'inn': '',
	'kpp': '',
	'date_register': '',
	'organization_address': '',
	'organization_address_fakt': '',
	'organization_address_notions': '',
	'fio_boss': '',
	'pravo_without': '',
	'predstaviteli': '',
	'doverennost': '',
	'organization_email': '',
	'organization_phone': '',
	'organization_nalogi': '',
	'organization_rekviziti': '',
	'ystav_copy': '',
	'svidetelstvo': '',
	'vipiska': '',
	'copy_pasport': '',
	'spravka': '',
	'yd_nats': '',
	'big_deal': '',
	'deal_win': '',
	'organization_opit': '',
	'bos_opit': ''
}

export default {
	name: 'FprkProject',
	data() {
		return {
			project: {
				project_data: {
					theme: [],
					predpol_locations: [
						{
							'predpol_country': '',
							'predpol_city': '',
							'predpol_region': ''
						}
					],
					fprk_category: '',
					prezentation: '',
					sinopsis: '',
					regiser_ekspl: '',
					rashodi: '',
					rashodi_2: '',
					plan_realizatii: '',
					link: '',
					link_video: '',
					soglasie: '',
					pisma2: '',
					additional: '',
					zayavlenie: '',
					is_publish_112: false,
					is_publish_137: false,
					social_valibility: '',
					aim_auditory: '',
					plan_promotion: '',
					canals: ''
				}
			},
			user: null,
			cities: [],
			tabNum: 1,
			isLoading: true,
			isSubmitted: false,
			isDataUpdating: false,
			isUserFillProfile: false,
			isUserFillFprkProfile: false,
			project_status: '',
			isShow: false,
			selectedCompetitionId: 137,
			validationRules: [],
			competition: null,
			competitions: [],
			totalCompetitions: 0,
			themes: [
				'Учись (Поиск собственного индивидуального пути в профессии: наставничество, школы и институты, мотивация молодежи к освоению инженерных и рабочих профессий)',
				'Изобретай (Технологическое будущее: развитие науки, инновации и технический прогресс в промышленной индустрии)',
				'Помни (Фильмы-портреты о выдающихся личностях и летопись важных событий для будущих поколений)',
				'Действуй (Мотивация к физическому, духовному, нравственному развитию, гуманизм, созидание и творчество)',
				'Твори (Новые имена в искусстве и креативных индустриях регионов, современные тренды в народном ремесле, музыке, живописи, дизайне)',
				'Береги (Экология: курс на бережное отношение к природе и охране экосистем)',
				'Путешествуй (Туристический потенциал регионов: национальное культурное наследие, открытие новых достопримечательностей и маршрутов для развития внутреннего туризма)',
				'Объединяй (Дружба народов большой страны: межнациональное браки, сотрудничество, сотворчество)',
				'Цени (Семья — связь поколений, традиционные ценности и поддержка детства)'
			],
		}
	},
	components: {
		BaseLocationCountryRegionCity,
		BasePdfUploader,
		TinymceEditor,
		SaveInfo,
		BaseInput,
		Spin,
		Field,
		Form,
		BaseLocationOnlyCityRegion,
		BaseLocationOnlyCountry,
		BaseTextarea,
		RadioInput,
		BaseChoiseSelect
	},
	mounted: async function () {
		if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
			alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
		}
		this.checkIsUserFillProfile();
		this.getProjectStatus();
		
		await this.getData();
		await this.getUserData();
		await this.clearOldValues();
		this.loadCompetition(137);
		this.loadCompetitions(1);
	},
	methods: {
		async getData(checkErrors = true, showModal = false) {
			const self = this;
			
			// const response = await axios.get('/get_all_countries', {
			// 	headers: {
			// 		'Accept': 'application/json',
			// 	}
			// })
			// 	.catch(error => {
			// 		console.log(error);
			// 	});
			// this.countries = response.data;
			
			// const items = await axios.get('/get_world_cities');
			// this.cities = items.data;
			
			
			await axios.get('/api/projects/' + window.projectId, {
				headers: {
					'Accept': 'application/json',
				}
			})
				.then(response => {
					response.data.project_data = Json.handle_json_field(response.data.project_data, self.project.project_data);
					if (response.data.project_data?.predpol_locations?.length === 0) {
						response.data.project_data.predpol_locations.push({
							predpol_country: '',
							predpol_city: '',
							predpol_region: ''
						});
					}
					
					
					if (typeof response.data.project_data.predpol_locations === 'string') {
						try {
							response.data.project_data.predpol_locations = JSON.parse(response.data.project_data.predpol_locations);
						} catch (error) {
							response.data.project_data.predpol_locations = [{
								predpol_country: '',
								predpol_city: '',
								predpol_region: ''
							}];
						}
					}
					
					// for (var key in project_data) {
					//   if (key === 'theme') {
					//     self.project.project_data[key] = response.data.project_data[key] ?? [];
					//   } else {
					//     self.project.project_data[key] = response.data.project_data[key] ?? '';
					//   }
					// }
					
					self.project = response.data;
					
					if (self.project.stage === null) {
						self.project.stage = []
					}
					
					if (self.project.stage.length === 0) {
						self.project.stage.push({
							'whois': "",
							'last_name': "",
							"first_name": "",
							"patronymic": "",
							"pasport": "",
							"role": "",
							"opit": [],
							"other_country": false,
							"country": "",
							"gorod": "",
							"region": "",
							"addinfo": ""
						});
					}
					
					let hasAuthorScenario = self.project.stage.some(function (obj) {
						return obj.whois === 'author_scenario';
					});
					
					let hasRegiser = self.project.stage.some(function (obj) {
						return obj.whois === 'regiser';
					});
					
					if (!hasRegiser) {
						self.project.stage.unshift({
							'whois': "regiser",
							'last_name': "",
							"first_name": "",
							"patronymic": "",
							"pasport": "",
							"role": "",
							"opit": [],
							"other_country": false,
							"country": "",
							"gorod": "",
							"region": "",
							"addinfo": ""
						});
					}
					
					if (!hasAuthorScenario) {
						self.project.stage.unshift({
							'whois': "author_scenario",
							'last_name': "",
							"first_name": "",
							"patronymic": "",
							"pasport": "",
							"role": "",
							"opit": [],
							"other_country": false,
							"country": "",
							"gorod": "",
							"region": "",
							"addinfo": ""
						});
					}
					
					// if (self.project.project_data['theme'] === true) {
					//   self.project.project_data['theme'] = [];
					// }
					
					
					// if (self.project.project_data === null || Array.isArray(self.project.project_data)) {
					//   self.project.project_data = {};
					// }
					
					
					if (checkErrors) {
						if (showModal) {
							self.checkErrors(false, true);
						} else {
							self.checkErrors(false);
						}
					}
					
					self.isLoading = false;
					self.isDataUpdating = false;
				})
				.catch(error => {
					console.log(error);
				});
		},
		async clearOldValues() {
			// Проверяем темы проекта
			if (this.project?.project_data?.theme) {
				// Проверяем каждое значение темы на соответствие списку доступных тем
				const validThemes = this.project.project_data.theme.filter(theme =>
					this.themes.includes(theme)
				);
				
				// Если есть невалидные темы или длина массива больше 1, очищаем массив
				if (validThemes.length !== this.project.project_data.theme.length || this.project.project_data.theme.length > 1) {
					this.project.project_data.theme = [];
					// Сохраняем изменения
					await this.saveData();
				}
			}
			
			// В будущем здесь можно добавить очистку других полей, если потребуется
		},
		handleThemeChange(selectedTheme) {
			// Заменяем массив на новый с единственным выбранным значением
			this.project.project_data.theme = [selectedTheme];
			this.saveData();
		},
		async getUserData() {
			const schema = structuredClone(data_schema);
			
			const item = await axios.get('/api/users/' + this.currentUserId + '.json');
			item.data.user_data = Json.handle_json_field(item.data.user_data, schema);
			
			this.user = item.data;
			this.isDataUpdating = false;
		},
		saveData: function () {
			let self = this;
			
			//console.log(this.project_status);
			
			if (this.project_status === 'Заполнен и отправлен на конкурс') {
				if (window.password && window.password === '12345') {
					console.log('debug');
				} else {
					message.error('Проект уже отправлен на конкурс. Редактирование запрещено.');
					return;
				}
			}
			
			//console.log(this.isSubmitted, this.project?.project_data?.is_publish_137);
			if (!window.password && !this.isSubmitted && this.project?.project_data?.is_publish_137) {
				this.sendForm();
				return;
			}
			
			
			if (!window.password && this.user?.username !== 'ychastnikcheshkin@gmail.com') {
				if (this.competitionStage === 'Завершен' || this.competitionStage === 'Обработка заявок') {
					message.error('Прием заявок на конкурс завершен. Редактирование проекта запрещено. Изменения не сохранятся.');
					return;
				}
			}
			
			if (!this.isDataUpdating) {
				this.isDataUpdating = true;
				
				axios.patch('/api/projects/' + window.projectId,
					{
						'name': this.project.name,
						'additionalInfo': this.project.additional_info,
						'stage': this.project.stage,
						'country': this.project.country,
						'city': this.project.city,
						'region': this.project.region,
						'countryTown': this.project.country_town ? this.project.country_town.toString() : '',
						'projectData': this.project.project_data
					},
					{
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/merge-patch+json',
						}
					}
				).then((response) => {
					if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
						alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
						window.location.reload();
					}
					
					self.getData()
				}).catch(error => {
					console.log(error);
					alert('Ошибка получения данных')
				});
			}
		},
		saveUserData() {
			let self = this;
			if (!this.isDataUpdating) {
				this.isDataUpdating = true;
				
				axios.patch('/api/users/' + this.currentUserId,
					{
						'userData': this.user.user_data
					},
					{
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/merge-patch+json',
						}
					}
				).then((response) => {
					if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
						alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
						window.location.reload();
					}
					
					self.getUserData()
				}).catch(error => {
					console.log(error);
					alert('Ошибка получения данных')
				});
			}
		},
		onPdfError(data) {
			message.error(data.detail);
		},
		getProjectStatus() {
			axios.get('/project/getProjectStatusRrvb/' + this.currentProjectId).then((res) => {
				this.project_status = res.data;
			});
		},
		removeNonMatchingElements(sourceArray, filterArray) {
			if (sourceArray && filterArray) {
				const resultArray = sourceArray.filter(item => filterArray.includes(item));
				return resultArray;
			} else {
				return filterArray;
			}
		},
		isRequired(value) {
			if (typeof value === 'boolean') {
				return value;
			}
			if (value === undefined || value === null) {
				return false;
			}
			if (Array.isArray(value)) {
				return value && value.length > 0;
			} else {
				return value && value.trim().length > 0;
			}
		},
		validateSynopsis(value) {
			if (!value || value.length < 500) {
				return 'Краткий синопсис должен содержать не менее 500 символов';
			}
			return true;
		},
		isOnePredpolLocationsNotFilled(values) {
			let res = false;
			values.forEach((item) => {
				if (item.predpol_country.length === 0 || item.predpol_city.length === 0 || item.predpol_region.length === 0) {
					res = true;
				}
			});
			return !res;
		},
		validateField(field) {
			const self = this;
			if (field.parentEntity !== undefined) {
				if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0))) {
					if (!self.errors.find(x => x.text === field.errorText)) {
						self.errors.push({
							text: field.errorText,
							order: field.order ? field.order : '1'
						});
					}
				}
			} else {
				if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName]?.length === 0 || self.project[field.fieldName] === 0)) {
					if (!self.errors.find(x => x.text === field.errorText)) {
						self.errors.push({
							text: field.errorText,
							order: field.order ? field.order : '1'
						});
					}
				}
			}
		},
		async checkIsUserFillProfile() {
			
			const res = await axios.get('/isUserFillProfile');
			this.isUserFillProfile = res.data;
			
			const res2 = await axios.get('/isUserFillFprkProfile');
			this.isUserFillFprkProfile = res2.data;
			
		},
		checkErrors(withScroll = true, showModal = false) {
			const self = this;
			this.isLoading = true;
			self.errors = [];
			
			this.validationRules.forEach(function (field) {
				self.validateField(field)
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					self.validateField(field)
				});
				this.errors.sort((a, b) => a.order > b.order ? 1 : -1);
			}
			
			if (!self.isUserFillProfile) {
				self.errors.push({
					text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/myprofile?check=true">https://script.moviestart.ru/myprofile</a>',
					order: '1'
				});
			}
			if (showModal) {
				self.showModal();
			}
			self.isLoading = false;
			if (withScroll && self.errors.length > 0) {
				if (document.getElementById("project_form")) {
					document.getElementById("project_form").scrollIntoView();
				}
			}
			
		},
		isFieldRequired(fieldName) {
			let res = false;
			this.validationRules.forEach(function (field) {
				if (
					(field.fieldName === fieldName || field?.altFieldName === fieldName)
					&& field.isRequired) {
					res = true;
				}
			});
			if (this.selectedCompetition?.projectRules) {
				this.selectedCompetition?.projectRules.forEach(function (field) {
					if (
						(field.fieldName === fieldName || field?.altFieldName === fieldName)
						&& field.isRequired) {
						res = true;
					}
				});
			}
			return res;
		},
		addOpit(index) {
			this.project.stage[index].opit.push({
				"project_name": "",
				"year_realezatii": "",
				"role": "",
				"link": "",
				"description": ""
			})
		},
		addItem() {
			this.project.stage.push({
				'whois': "",
				'last_name': "",
				"first_name": "",
				"patronymic": "",
				"pasport": "",
				"role": "",
				"opit": [],
				"other_country": false,
				"country": "",
				"gorod": "",
				"region": "",
				"addinfo": ""
			})
		},
		deleteItem(index) {
			this.project.stage = this.project.stage.filter(function (el, inner_index) {
				return inner_index != index;
			});
			this.saveData();
		},
		deleteOpitItem(index, index2) {
			this.project.stage[index].opit = this.project.stage[index].opit.filter(function (el, inner_index) {
				return inner_index != index2;
			});
			this.saveData();
		},
		async sendForm() {
			this.isSubmitted = true;
			
			//Ждем пока изменятся изменненные в поле данные
			this.$nextTick(async () => {
				const valid = await this.$refs.project_form.validate();
				if (valid?.valid) {
					if (!this.project?.project_data?.is_publish_137) {
						this.project.project_data.is_publish_137 = true;
					}
					await this.saveData();
					this.getProjectStatus();
					this.isSubmitted = false;
				} else {
					if (this.project?.project_data?.is_publish_137) {
						this.project.project_data.is_publish_137 = false;
					}
					await this.saveData();
					this.getProjectStatus();
					if (document.getElementById("project_form")) {
						document.getElementById("project_form").scrollIntoView();
					}
				}
			});
		},
		getFieldNameByIndex(index) {
			let res = '';
			if (index === 'name') {
				res = 'Название проекта';
			}
			if (index === 'country') {
				res = 'Страна съемок';
			}
			if (index === 'city') {
				res = 'Город съемок';
			}
			if (index === 'region') {
				res = 'Регион съемок';
			} else if (index === 'fprk_category') {
				res = 'Категория';
			} else if (index === 'predpol_locations') {
				res = 'Предполагаемые места съемок';
			} else if (index === 'theme') {
				res = 'Тема проекта';
			} else if (index === 'additional_info') {
				res = 'Краткий синопсис Проекта (минимальное количество символов 500)';
			} else if (index === 'sinopsis') {
				res = 'Расширенный синопсис Проекта';
			} else if (index === 'regiser_ekspl') {
				res = 'Режиссерская экспликация Проекта, подписанная режиссером';
			} else if (index === 'prezentation') {
				res = 'Презентация Проекта в формате pdf';
			} else if (index === 'plan_realizatii') {
				res = 'Календарно-постановочный план';
			}
			else if (index === 'link_video') {
				res = 'Видеообращение авторов с устной презентацией проекта, представлением команды и опыта команды';
			}
			else if (index === 'soglasie') {
				res = 'Письменное согласие героя (одного из героев) проекта на участие в производстве (создании) Проекта';
			} else if (index === 'zayavlenie') {
				res = 'Анкета участника - Подтверждение подачи Заявки на участие в Конкурсном отборе проектов (п. 4.7.17 Документации Конкурсного отбора проектов)';
			} else if (index === 'country_town') {
				res = 'У проекта нет финансовой поддержки за счёт федерального и/или муниципального финансирования';
			} else if (index.startsWith('whois')) {
				res = 'Добавить участника проекта';
			} else if (index.startsWith('last_name')) {
				res = 'Фамилия';
			} else if (index.startsWith('first_name')) {
				res = 'Имя';
			} else if (index.startsWith('patronymic')) {
				res = 'Отчество';
			} else if (index.startsWith('role')) {
				res = 'Роль в заявленном проекте';
			} else if (index.startsWith('opit_item_project_name')) {
				res = 'Опыт - Название проекта';
			} else if (index.startsWith('opit_item_year_realezatii')) {
				res = 'Опыт - Год реализации';
			} else if (index.startsWith('opit_item_role')) {
				res = 'Опыт - Роль в проекте';
			} else if (index.startsWith('opit_item_link')) {
				res = 'Опыт - Ссылка на информацию о проекте';
			} else if (index.startsWith('opit_item_description')) {
				res = 'Опыт - Сведения об участии ранее созданных проектов в российских и международных фестивалях';
			} else if (index.startsWith('opit_project_gorod')) {
				res = 'Город';
			} else if (index.startsWith('opit_project_country')) {
				res = 'Страна';
			} else if (index.startsWith('dogovor')) {
				res = 'Договор с авторами';
			} else if (index.startsWith('opit')) {
				res = 'Опыт участника проекта';
			} else if (index === 'organization_name') {
				res = 'Анкета участника - 1. Полное наименование организации либо фамилия, имя и отчество (при наличии) Участника - индивидуального предпринимателя';
			} else if (index === 'ogrn') {
				res = 'Анкета участника - 3. ОГРН/ОГРНИП';
			} else if (index === 'inn') {
				res = 'Анкета участника - 4. ИНН';
			} else if (index === 'date_register') {
				res = 'Анкета участника - 6. Дата регистрации организации/индивидуального предпринимателя';
			}
			// else if (index === 'organization_address') {
			// 	res = 'Анкета участника - 7. Адрес (местонахождение)/местожительства (для индивидуального предпринимателя)';
			// }
			else if (index === 'organization_address_fakt') {
				res = 'Анкета участника - 8. Фактическое местонахождение организации/ индивидуального предпринимателя';
			} else if (index === 'organization_address_notions') {
				res = 'Анкета участника - 9. Адрес для направления организации/индивидуальному предпринимателю юридически значимых сообщений';
			} else if (index === 'fio_boss') {
				res = 'Анкета участника - 10. Фамилия, имя и отчество (при наличии) руководителя организации';
			} else if (index === 'organization_email') {
				res = 'Анкета участника - 15. Адрес электронной почты организации/индивидуального предпринимателя';
			} else if (index === 'organization_phone') {
				res = 'Анкета участника - 16. Контактный телефон';
			} else if (index === 'organization_nalogi') {
				res = 'Анкета участника - 13. Система налогообложения (ОСНО, УСН 15%, УСН 6%)';
			} else if (index === 'organization_rekviziti') {
				res = 'Анкета участника - 14. Банковские реквизиты';
			} else if (index === 'svidetelstvo') {
				res = 'Анкета участника - 18. Свидетельство о государственной регистрации или Лист записи ЕГРЮЛ/ЕГРИП';
			} else if (index === 'spravka') {
				res = 'Анкета участника - 21. Cправка об исполнении налогоплательщиком (плательщиком сбора, плательщиком страховых взносов, налоговым агентом) обязанности по уплате налогов, сборов, страховых взносов, пеней, штрафов, процентов по форме по КНД 1120101';
			}
			else if (index === 'yd_nats') {
				res = 'Анкета участника - 17. Наличие удостоверения национального фильма / планируется ли получение удостоверения национального фильм';
			} else if (index === 'vipiska') {
				res = 'Анкета участника - 19. Выписка в электронном виде из единого государственного реестра юридических лиц или из единого государственного реестра индивидуальных предпринимателей, выданная не позднее чем за один месяц до подачи Заявки';
			} else if (index === 'organization_opit') {
				res = 'Анкета участника - Опыт организации';
			} else if (index === 'bos_opit') {
				res = 'Анкета участника - Опыт руководителя';
			}
			else if (index === 'social_valibility') {
				res = 'Общественная значимость';
			}
			else if (index === 'aim_auditory') {
				res = 'Целевая аудитория';
			}
			else if (index === 'plan_promotion') {
				res = 'План фестивального продвижения фильма после завершения реализации Проекта';
			}
			else if (index === 'canals') {
				res = 'Каналы информационного охвата реализации Проекта';
			}
			
			
			return res;
		},
		showModal() {
			this.isShow = true;
		},
		closeModal() {
			this.isShow = false
		},
		async loadCompetition(id) {
			const item = await axios.get('/api/competitions/' + id);
			this.competition = item.data;
			
			// axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId, {
			//   headers: {
			//     'Accept': 'application/ld+json',
			//   }
			// })
			//   .then(response => {
			//     self.competitions = [response.data];
			//     self.isLoading = false;
			//   })
			//   .catch(error => {
			//     console.log(error);
			//   });
		},
		loadCompetitions(pageNum) {
			const self = this;
			this.currentPageNum = pageNum;
			self.isLoading = true;
			
			let url = '/competition/apiGetCompetitions/' + window.projectId + '/' + pageNum;
			
			if (pageNum === 0) {
				url = '/competition/apiGetCompetitions/' + window.projectId
			}
			
			axios.get(url, {
				headers: {
					'Accept': 'application/ld+json',
				}
			})
				.then(response => {
					self.isLoading = false;
					
					this.competitions = response.data['competitions'];
					this.totalCompetitions = response.data['total'];
				})
				.catch(error => {
					console.log(error);
				});
		},
		changeCurrentTab(num) {
			this.tabNum = num;
			document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
		},
		makeProjectInfo(categoryId, isProjectInfoSubmitted) {
			if (isProjectInfoSubmitted === '0' || isProjectInfoSubmitted === undefined) {
				this.isLoading = true;
				axios.get('/competition/apiAddProject/' + this.selectedCompetitionId + '/' + window.projectId + '/' + categoryId, {
					headers: {
						'Accept': 'application/ld+json',
					}
				})
					.then(response => {
						if (response.data['error']) {
							this.isLoading = false;
							alert(response.data['error'])
						}
						this.loadCompetitions(this.currentPageNum)
						this.getProjectStatus();
						this.isShow = false;
					})
					.catch(error => {
						console.log(error);
					});
			}
		},
		delete_predpol_locations(index) {
			this.project?.project_data?.predpol_locations?.splice(index, 1);
			this.saveData();
		}
		
	},
	computed: {
		currentProjectId: function () {
			return window.projectId;
		},
		currentUserId: function () {
			return window.userId;
		},
		citiestoinput: function () {
			const res = this.cities.map((field) => field.ru_name);
			return res;
		},
		percent_region: function () {
			if (this.project?.stage !== undefined) {
				const not_capital_members = this.project.stage.map((field) => {
					if (field?.gorod) {
						if (field?.gorod.length === 0 || field?.other_country || field?.gorod === 'Москва' || field?.gorod === 'Санкт-Петербург' || field?.gorod === 'Московская область' || field?.gorod === 'Ленинградская область') {
							return undefined;
						}
					}
					return field;
				}).filter((item) => item !== undefined);
				
				return this.project.stage.length + ' человек (' + Math.round(not_capital_members.length / this.project.stage.length * 100, 1) + '% из регионов)';
			}
			return 0;
			
		},
		selectedCompetition() {
			return this.competitions.find(el => el.id === parseInt(this.selectedCompetitionId));
		},
		competitionStage() {
			return this.competition?.stage;
		},
		isProjectPublish() {
			return this.project?.project_data?.is_publish_137 == 'true' ? true : false;
		}
	},
}
</script>

<template>
	<div>
		<SaveInfo
			:isDataUpdating="isDataUpdating"
		></SaveInfo>
		<div v-if="!isLoading && project?.id && user !== null">
			<Form id="project_form" ref="project_form" v-slot="{errors}">
				
				<div class="content_block_top_label">
					<p>Текущий выбранный конкурс: <strong>Россия - взгляд в будущее! 2025</strong></p>
					<div class="columns">
						<div class="column" style="display: flex; align-items: center">
							<p style="margin-bottom: 0;">Для отправки проекта на конкурс необходимо заполнить все
								обязательные поля и отправить проект на конкурс.</p>
						</div>
						<div class="column">
							<template v-if="project_status === 'Черновик'">
								<div style="display:flex; flex-direction: column; align-items: flex-end; justify-content: flex-end">
									<p class="current_status" style="margin-bottom: 0; margin-right: 0;"><span
										class="current_status__text">Текущий статус проекта:</span> <span class="">Черновик</span>
									</p>
									<div>
										<p style="margin-top: 1em;"><a @click="sendForm" class="button6">ОТПРАВИТЬ НА
											КОНКУРС</a></p>
									</div>
								</div>
							</template>
							
							<template v-if="project_status !== 'Черновик'">
								<div style="display:flex; flex-direction: column; align-items: flex-end;">
									<p class="current_status"><span
										class="current_status__text">Текущий статус проекта:</span> <span
										class="current_status__value">Заполнен</span></p>
									<template v-if="isUserFillProfile">
										<template v-if="project_status === 'Заполнен и отправлен на конкурс'">
											<p style="margin-bottom: 0;"><strong>Проект отправлен на конкурс</strong></p>
										</template>
										<template v-else>
											<p style="margin: 30px 0;"><a class="button6"
											                              style=" border: 2px solid #F69F22;"
											                              @click.prevent="showModal">ОТПРАВИТЬ НА
												КОНКУРС</a>
											</p>
										</template>
									</template>
									<template v-else>
										<p style="
                                                       "><strong>Чтобы завершить отправку проекта на конкурс, заполните
											информацию о себе в <a href="/myprofile?check=1" target="_blank">профиле
												пользователя</a>.</strong></p>
									</template>
								</div>
							</template>
						</div>
					</div>
					<template v-if="!isProjectPublish">
						<template v-if="isUserFillProfile">
							<p>Проект можно редактировать до окончания приема заявок.</p>
						</template>
					</template>
					
					<Field style="display: none" v-model="project.name" name="name"
					       :rules="isRequired"></Field>
					
					<!--										<Field style="display: none" v-model="project.country" name="country"-->
					<!--                           :rules="isRequired"></Field>-->
					<!--                    <Field style="display: none" v-model="project.city" name="city"-->
					<!--                           :rules="isRequired"></Field>-->
					<!--                    <Field style="display: none" v-model="project.region" name="region"-->
					<!--                           :rules="isRequired"></Field>-->
					
					
					<Field style="display: none" v-model="project.project_data.predpol_locations"
					       name="predpol_locations" :rules="isOnePredpolLocationsNotFilled"></Field>
					
					<Field style="display: none" v-model="project.project_data.fprk_category"
					       name="fprk_category" :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.theme" name="theme"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.additional_info" name="additional_info"
					       :rules="[isRequired, validateSynopsis]"></Field>
					<Field style="display: none" v-model="project.project_data.sinopsis" name="sinopsis"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.regiser_ekspl"
					       name="regiser_ekspl"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.prezentation"
					       name="prezentation"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.rashodi" name="rashodi"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.plan_realizatii"
					       name="plan_realizatii"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.plan_realizatii"
					       name="plan_realizatii"
					       :rules="isRequired"></Field>
					
					<Field style="display: none" v-model="project.project_data.link_video"
					       name="link_video"
					       :rules="isRequired"></Field>
					
					
					<Field style="display: none" v-model="project.project_data.social_valibility"
					       name="social_valibility"
					       :rules="isRequired"></Field>
					
					<Field style="display: none" v-model="project.project_data.aim_auditory"
					       name="aim_auditory"
					       :rules="isRequired"></Field>
					
					<Field style="display: none" v-model="project.project_data.plan_promotion"
					       name="plan_promotion"
					       :rules="isRequired"></Field>
					
					<Field style="display: none" v-model="project.project_data.canals"
					       name="canals"
					       :rules="isRequired"></Field>
					
					
					<template v-for="(item, index) in project.stage" :key="index">
						<Field style="display: none" v-model="project.stage[index].whois"
						       :name="'whois'+index"
						       :rules="isRequired"></Field>
						<Field style="display: none" v-model="project.stage[index].last_name"
						       :name="'last_name'+index"
						       :rules="isRequired"></Field>
						<Field style="display: none"
						       v-model="project.stage[index].first_name"
						       :name="'last_name'+index" :rules="isRequired"></Field>
						<Field style="display: none"
						       v-model="project.stage[index].patronymic"
						       :name="'patronymic'+index" :rules="isRequired"></Field>
						
						<template
							v-if="item.whois == 'regiser' || item.whois == 'regiser2' || item.whois == 'author_scenario2' || item.whois == 'author_scenario' || item.whois == 'compositor'">
							<Field style="display: none"
							       v-model="project.project_data['dogovor'+index]"
							       :name="'dogovor'+index" :rules="isRequired"></Field>
						</template>
						
						
						<Field v-if="project.stage[index].opit.length === 0" style="display: none"
						       v-model="project.stage[index].opit"
						       :name="'opit'+index" :rules="isRequired"></Field>
						<template v-else>
							<template v-for="(opit_item, index_opit_item) in project.stage[index].opit" :key="index_opit_item">
								<Field style="display: none"
								       v-model="project.stage[index].opit[index_opit_item].project_name"
								       :name="'opit_item_project_name_'+index+'_'+index_opit_item" :rules="isRequired"></Field>
								<Field style="display: none"
								       v-model="project.stage[index].opit[index_opit_item].year_realezatii"
								       :name="'opit_item_year_realezatii_'+index+'_'+index_opit_item" :rules="isRequired"></Field>
								<Field style="display: none"
								       v-model="project.stage[index].opit[index_opit_item].role"
								       :name="'opit_item_role_'+index+'_'+index_opit_item" :rules="isRequired"></Field>
								<Field style="display: none"
								       v-model="project.stage[index].opit[index_opit_item].link"
								       :name="'opit_item_link_'+index+'_'+index_opit_item" :rules="isRequired"></Field>
								<Field style="display: none"
								       v-model="project.stage[index].opit[index_opit_item].description"
								       :name="'opit_item_description_'+index+'_'+index_opit_item" :rules="isRequired"></Field>
							
							</template>
						</template>
						
						<template v-if="item.whois === 'other'">
							<Field style="display: none" v-model="project.stage[index].role"
							       :name="'role'+index" :rules="isRequired"></Field>
						</template>
						
						<template v-for="(opit, index2) in item.opit" :key="index2">
							<Field style="display: none"
							       v-model="project.stage[index].opit[index2].project_name"
							       :name="'opit_project_name'+index2"
							       :rules="isRequired"></Field>
							<Field style="display: none"
							       v-model="project.stage[index].opit[index2].year_realezatii"
							       :name="'opit_project_year_realezatii'+index2"
							       :rules="isRequired"></Field>
							
							<Field style="display: none"
							       v-model="project.stage[index].opit[index2].role"
							       :name="'opit_project_role'+index2"
							       :rules="isRequired"></Field>
							<Field style="display: none"
							       v-model="project.stage[index].opit[index2].link"
							       :name="'opit_project_link'+index2"
							       :rules="isRequired"></Field>
							<Field style="display: none"
							       v-model="project.stage[index].opit[index2].description"
							       :name="'opit_project_description'+index2"
							       :rules="isRequired"></Field>
						</template>
						
<!--						<Field style="display: none" v-if="item.other_country" v-model="project.stage[index].country"-->
<!--						       :name="'opit_project_country'+index" :rules="isRequired"></Field>-->
						<Field style="display: none" v-if="!item.other_country" v-model="project.stage[index].gorod"
						       :name="'opit_project_gorod'+index" :rules="isRequired"></Field>
					</template>
					
					
					<Field style="display: none" v-model="project.project_data.soglasie" name="soglasie"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.project_data.zayavlenie" name="zayavlenie"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="project.country_town" name="country_town"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_name"
					       name="organization_name" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.ogrn" name="ogrn"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.inn" name="inn"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.date_register" name="date_register"
					       :rules="isRequired"></Field>
<!--					<Field style="display: none" v-model="user.user_data.organization_address"-->
<!--					       name="organization_address" :rules="isRequired"></Field>-->
					<Field style="display: none" v-model="user.user_data.organization_address_fakt"
					       name="organization_address_fakt" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_address_notions"
					       name="organization_address_notions" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_email"
					       name="organization_email" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_phone"
					       name="organization_phone" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.fio_boss" name="fio_boss"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_nalogi"
					       name="organization_nalogi" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_rekviziti"
					       name="organization_rekviziti" :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.svidetelstvo" name="svidetelstvo"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.spravka" name="spravka"
					       :rules="isRequired"></Field>
					<!--                    <Field style="display: none" v-model="user.user_data.big_deal" name="big_deal"-->
					<!--                           :rules="isRequired"></Field>-->
					<!--                    <Field style="display: none" v-model="user.user_data.deal_win" name="deal_win"-->
					<!--                           :rules="isRequired"></Field>-->
<!--					<Field style="display: none" v-model="user.user_data.yd_nats" name="yd_nats"-->
<!--					       :rules="isRequired"></Field>-->
					<Field style="display: none" v-model="user.user_data.vipiska" name="vipiska"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.organization_opit" name="organization_opit"
					       :rules="isRequired"></Field>
					<Field style="display: none" v-model="user.user_data.bos_opit" name="bos_opit"
					       :rules="isRequired"></Field>
				</div>
				
				<div class="errors-block"
				     v-if="Object.keys(errors).length > 0 && (project.noPremiere || this.isSubmitted)">
					<b>Пожалуйста, заполните поля:</b>
					<ul>
						<li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
							обязательно для заполнения
						</li>
					</ul>
				</div>
				
				
				<div class="tabs">
					<ul>
						<li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Проект</a>
						</li>
						<li @click="changeCurrentTab(2)" class="tab" :class="tabNum === 2 ? 'is-active' : ''"><a>Участник:
							Организация/ИП</a></li>
					</ul>
				</div>
				<div id="tabContent">
					<div v-if="tabNum === 1" id="tab1" class="content-tab">
						<div class="columns">
							<div class="column">
								<div class="subtitle">ОБЩАЯ ИНФОРМАЦИЯ</div>
								
								<BaseInput
									label="1. Название проекта"
									v-model="project.name"
									:is-required="true"
									:isDataUpdated="isDataUpdating"
									:isFormSubmitted="isSubmitted"
									@onChange="saveData"
								></BaseInput>
								
								
								<div class="field">
									<label class="req">2. Категория</label>
									<div class="select-field">
										<select :disabled="isDataUpdating" @change="saveData"
										        v-model="project.project_data.fprk_category">
											<option value="choise2">Короткометражный документальный фильм</option>
										</select>
									</div>
								</div>
								
								<div class="field">
									<label class="req">3. Тема Проекта</label>
									<div id="project_zhanr">
										<template v-for="(theme,index) in themes" :key="index">
											<div class="checkbox__wrapper">
<!--												v-model="project.project_data.theme" @change="saveData" -->
												<input
													:disabled="isDataUpdating"
													type="checkbox"
												  :id="'project_zhanr_'+index"
												  :value="theme"
													:checked="project.project_data.theme.includes(theme)"
													@change="handleThemeChange(theme)"
												>
												<label :for="'project_zhanr_'+index">{{ theme }}</label>
											</div>
										</template>
									</div>
								</div>
								
								
								<!--                                <div class="field">-->
								<!--                                    <label class="req">Тема Проекта</label>-->
								<!--                                    <template v-for="(theme,index) in themes" :key="index">-->
								<!--																				-->
								<!--																			<RadioInput-->
								<!--																							v-model="project.project_data.theme"-->
								<!--																							:label="theme"-->
								<!--																							:value="theme"-->
								<!--																							:id="'project_theme'+index"-->
								<!--																							@onChange="saveData"-->
								<!--																			></RadioInput>-->
								<!--																		</template>-->
								<!--                                </div>-->
								
								
								<div class="columns">
									<div class="column">

										
										<div class="field">
											<label>4. Предполагаемые места съемок</label>
											<template v-for="(item,index) in project.project_data.predpol_locations" :key="index">
												<BaseLocationCountryRegionCity
													v-model:country="item.predpol_country"
													v-model:city="item.predpol_city"
													v-model:region="item.predpol_region"
													labelCountry="Страна предполагаемого места съемок"
													labelCity="Город предполагаемого места съемок"
													labelRegion="Регион предполагаемого места съемок"
													:is-city-required="true"
													:is-country-required="true"
													:is-region-required="true"
													:countries="countries"
													@onChange="saveData"
												/>
												<p><a @click="delete_predpol_locations(index); ">Удалить</a></p>
											</template>
											<p style="margin: 30px 0;"><a class="button2"
											                              @click="project.project_data.predpol_locations.push({predpol_country: '', predpol_city: '', predpol_region: ''})"
											                              style="border: 2px solid rgb(246, 159, 34);">Добавить место
												съемок</a></p>
										</div>
									</div>
									<div class="column">
									
									</div>
								</div>
								
								
<!--								<TinymceEditor-->
<!--									label="Краткий синопсис Проекта (п. 4.7.10 Документации Конкурсного отбора) (объем не более 900 знаков)"-->
<!--									v-model="project.additional_info"-->
<!--									:isDataUpdating="isDataUpdating"-->
<!--									:is-required="true"-->
<!--									@update="saveData"-->
<!--								></TinymceEditor>-->
								
								<TinymceEditor
									id="project_additional_info"
									v-model="project.additional_info"
									label="5. Краткий синопсис Проекта (п. 4.7.10 Документации Конкурсного отбора) (объем не менее 500 знаков и не более 900 знаков)"
									@onChange="saveData"
									max_chars="900"
									min_chars="500"
									:isDataUpdating="isDataUpdating"
									:is-required="true"
									@update="saveData"
								/>
								
								<div class="columns">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											label="6. Презентация Проекта в формате pdf (п. 4.7.18 Документации Конкурсного отбора проектов)"
											:value="project.project_data.prezentation"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/prezentation/fprk'"
											objectKey="prezentation"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
								<div class="hr"></div>
								<div class="subtitle">ПОДРОБНЕЕ О ПРОЕКТЕ</div>
								
								<div class="columns columns-2">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											label="7. Расширенный синопсис Проекта, подписанный автором сценария (п. 4.7.11 Документации Конкурсного отбора) (объем не более трех страниц формата А4)"
											:value="project.project_data.sinopsis"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/sinopsis/fprk'"
											objectKey="sinopsis"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											label="8. Режиссерская экспликация Проекта, подписанная режиссером (п. 4.7.12 Документации Конкурсного отбора)"
											:value="project.project_data.regiser_ekspl"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/regiser_ekspl/fprk'"
											objectKey="regiser_ekspl"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
<!--								<div class="columns columns-2">-->
<!--									<div class="column"></div>-->
<!--								</div>-->
								
<!--								<div class="columns columns-2">-->
<!--									<div class="column">-->
<!--										<BasePdfUploader-->
<!--											:project="project"-->
<!--											:currentProjectId="currentProjectId"-->
<!--											description="<p><a href='https://disk.yandex.kz/i/U0pbG5Kb1Jwdog' target='_blank'>Ссылка на скачивание</a></p>"-->
<!--											label="9. Лимит затрат на проект с софинансированием (Приложение № 7.1)"-->
<!--											:value="project.project_data.rashodi_2"-->
<!--											pathToUpload="/project/uploadProjectFprkNew/"-->
<!--											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/rashodi_2/fprk'"-->
<!--											objectKey="rashodi_2"-->
<!--											entityKey="fprk"-->
<!--											:is-new-link="true"-->
<!--											@onChange="getData"-->
<!--											@onError="onPdfError"-->
<!--										></BasePdfUploader>-->
<!--									</div>-->
<!--								</div>-->
								
								<div class="columns columns-2">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											description="<p><a href='https://disk.yandex.ru/i/AEBEoZSivln0lA' target='_blank'>Ссылка на скачивание</a></p>"
											label="9. Календарно-постановочный план по форме, установленной Фондом (п. 4.7.14 Документации Конкурсного отбора)"
											:value="project.project_data.plan_realizatii"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/plan_realizatii/fprk'"
											objectKey="plan_realizatii"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											description="<p><a href='https://disk.yandex.ru/i/GZ4EuJGBOzaQvw' target='_blank'>Ссылка на скачивание</a></p>"
											label="10. Лимит затрат по форме, установленной Фондом, на реализацию (создание) Проекта"
											:value="project.project_data.rashodi"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/rashodi/fprk'"
											objectKey="rashodi"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
								<div class="bold_label">
									<BaseInput
										label="11. Видеообращение авторов с устной презентацией проекта, представлением команды и опыта команды"
										v-model="project.project_data.link_video"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										:is-required="true"
										@onChange="saveData"
									></BaseInput>
								</div>
								
								<div class="bold_label">
									<BaseInput
										label="12. Ссылка на видеоматериалы о проекте, который заявляется на конкурс"
										description="Сюда вы можете загрузить ссылку на тизер, трейлер или эпизод фильма, созданный творческой командой проекта."
										v-model="project.project_data.link"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveData"
									></BaseInput>
								</div>
								
								<TinymceEditor
									id="project_social_valibility"
									v-model="project.project_data.social_valibility"
									label="13. Общественная значимость (региональный и федеральный масштаб проекта, влияние проекта на общество, обоснование важности проекта, определение потенциальных зрителей, обоснование выбора темы и т.д.)"
									@onChange="saveData"
									max_chars="3000"
									:isDataUpdating="isDataUpdating"
									:is-required="true"
									@update="saveData"
								/>
								
								<TinymceEditor
									id="project_aim_auditory"
									v-model="project.project_data.aim_auditory"
									label="14. Целевая аудитория (определение потенциальных зрителей, их возраст, пол, социальное положение, место проживания)"
									@onChange="saveData"
									max_chars="500"
									:isDataUpdating="isDataUpdating"
									:is-required="true"
									@update="saveData"
								/>
								
								
								<TinymceEditor
									id="project_plan_promotion"
									v-model="project.project_data.plan_promotion"
									label="15. План фестивального продвижения фильма после завершения реализации Проекта"
									@onChange="saveData"
									max_chars="3000"
									:isDataUpdating="isDataUpdating"
									:is-required="true"
									@update="saveData"
								/>
								
								<TinymceEditor
									id="project_canals"
									v-model="project.project_data.canals"
									label="16. Каналы информационного охвата реализации Проекта (наименование конкретных ресурсов, которые будут задействованы в информационном сопровождении Проекта)"
									@onChange="saveData"
									max_chars="3000"
									:isDataUpdating="isDataUpdating"
									:is-required="true"
									@update="saveData"
								/>
								
								
								<div class="columns">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											description="<p><a href='https://disk.yandex.ru/i/ekC9duRQ4pOlLQ' target='_blank'>Ссылка на скачивание</a></p>"
											label="17. Письменное согласие героя (одного из героев) проекта на участие в производстве (создании) Проекта (п. 4.7.17 Документации Конкурсного отбора проектов)"
											:value="project.project_data.soglasie"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/soglasie/fprk'"
											objectKey="soglasie"
											:is-required="true"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
								<div class="columns">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											label="18. Письма региональных органов власти и (или) партнеров Проекта, подтверждающих оказание поддержки в реализации (создании) в качественном выражении (п.4.9 Документации Конкурсного отбора проектов). При наличии нескольких писем сформируйте их в один PDF документ."
											:value="project.project_data.pisma2"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/pisma2/fprk'"
											objectKey="pisma2"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
								<div class="columns">
									<div class="column">
										<BasePdfUploader
											:project="project"
											:currentProjectId="currentProjectId"
											label="19. Дополнительные документы Участника (4.9 Документации Конкурсного отбора проектов)"
											:value="project.project_data.additional"
											pathToUpload="/project/uploadProjectFprkNew/"
											:pathToDelete="'/project/removeProjectPdf/'+project.id+'/additional/fprk'"
											objectKey="additional"
											entityKey="fprk"
											:is-new-link="true"
											@onChange="getData"
											@onError="onPdfError"
										></BasePdfUploader>
									</div>
								</div>
								
								
								<div id="command">
									<div class="hr"></div>
									<div class="subtitle">ИНФОРМАЦИЯ О РУКОВОДИТЕЛЕ, АВТОРАХ ПРОЕКТА И ЧЛЕНАХ
										ТВОРЧЕСКОЙ ГРУППЫ
									</div>
									
									<div class="field req">
										<label class="req">Информация о руководителе и авторах Проекта (фамилия,
											имя,
											отчество (при наличии), роль в Проекте, опыт реализации похожих проектов
											(фильмография, сведения о реализации аналогичных проектов, ссылки на
											информацию и просмотр в сети «Интернет», сведения об участии ранее
											созданных
											проектов в российских и международных фестивалях) (п. 4.7.15 к
											Документации
											Конкурсного отбора проектов) <br>Сведения о проживании/регистрации
											авторов и
											членах творческой группы на территории субъектов Российской Федерации (в
											соответствии с дополнительными требованиями, установленными в пункте 7
											Приложения № 2 к Документации Конкурсного
											отбора
											проектов)</label>
									</div>
									
									<div class="command_wrapper" v-for="(item, index) in project.stage"
									     :key="index">
                                            <span class="delete_icon" @click="deleteItem(index)"
                                                  style="cursor: pointer; display: inline-block;"><i
	                                            class="far fa-trash-alt"></i></span>
										
										<template v-if="item.whois === 'regiser'">
											<p><strong>Заполните информацию о режиссере</strong></p>
										</template>
										<template v-else-if="item.whois === 'author_scenario'">
											<p><strong>Заполните информацию об авторе сценария</strong></p>
										</template>
										<template v-else-if="item.whois === 'regiser2'">
											<p><strong>Заполните информацию о режиссере</strong></p>
										</template>
										<template v-else-if="item.whois === 'author_scenario2'">
											<p><strong>Заполните информацию об авторе сценария</strong></p>
										</template>
										<template v-else>
											<div class="field">
												<label class="req">Добавить участника проекта</label>
												<div class="select-field">
													<select :disabled="isDataUpdating" @change="saveData"
													        v-model="item.whois">
														<option value="compositor">Композитор</option>
														<option value="regiser2">Режиссер</option>
														<option value="author_scenario2">Автор сценария</option>
														<option value="other">Другой
														</option>
													</select>
												</div>
											</div>
										</template>
										
										<div class="columns is-gapless" v-if="item.whois === 'other'">
											<div class="columns">
												<div class="column">
													<div class="field">
														<label for="project_fprk_name" class="req">Роль в заявленном
															проекте</label>
														<input @change="saveData" type="text" v-model="item.role"
														       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
													</div>
												</div>
											</div>
										</div>
										
										<div class="columns column-3-fio">
											<div class="column">
												<div class="field">
													<label for="project_fprk_name" class="req">Фамилия</label>
													<input @change="saveData" :name="'last-name'+index" type="text"
													       v-model="item.last_name"
													       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
												</div>
											</div>
											<div class="column">
												<div class="field">
													
													<label for="project_fprk_name" class="req">Имя</label>
													<input @change="saveData" type="text" v-model="item.first_name"
													       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
												</div>
											</div>
											<div class="column">
												<div class="field">
													
													<label for="project_fprk_name" class="req">Отчество</label>
													<input @change="saveData" type="text" v-model="item.patronymic"
													       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
												</div>
											</div>
										</div>
										<div class="hr2"></div>
										
										
										<div class="field">
											<label>Сведения об участвующих в реализации (создании) Проекта авторах и
												членах творческой группы, проживающих/зарегистрированных на
												территории
												иных субъектов Российской Федерации (пункт 7 Приложения № 2 Документации Конкурсного отбора проектов)</label>
										</div>
										<div class="field checkbox__wrapper"><input @change="saveData"
										                                            type="checkbox"
										                                            v-model="item.other_country"
										                                            :id="'other_country'+index"><label
											class="other_country"
											:for="'other_country' + index">
											Другая страна</label></div>
										<div v-if="item.other_country">
											<BaseLocationOnlyCountry
												label-country="Страна"
												:is-data-updating="isDataUpdating"
												:is-field-required="true"
												v-model="item.country"
												@onChange="saveData"
											/>
											
											
											<!--                                            <div class="field">-->
											<!--                                                <label for="project_fprk_name" class="req">Страна</label>-->
											<!--                                                <input @change="saveData" type="text" v-model="item.country"-->
											<!--                                                       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">-->
											<!--                                            </div>-->
										</div>
										<template v-else>
											<BaseLocationOnlyCityRegion
												v-model:city="item.gorod"
												v-model:region="item.region"
												@onChange="saveData"
												label-city="Город"
												label-region="Регион"
												:is-data-updating="isDataUpdating"
												:is-city-required="true"
												:is-region-required="true"
											></BaseLocationOnlyCityRegion>
										</template>
										
										<div class="hr2"></div>
										
										<div class="columns is-gapless"
										     v-if="item.whois === 'regiser' || item.whois === 'regiser2' || item.whois === 'author_scenario' || item.whois === 'author_scenario2' || item.whois === 'compositor'">
											<div class="column">
												<div class="field">
													<BasePdfUploader
														:project="project"
														:currentProjectId="currentProjectId"
														label="Сканированная копия договора"
														:value="project.project_data['dogovor'+index]"
														pathToUpload="/project/uploadProjectFprkNew/"
														:pathToDelete="'/project/removeProjectPdf/'+project.id+'/dogovor'+index+'/fprk'"
														:objectKey="'dogovor'+index"
														:is-required="true"
														entityKey="fprk"
														:is-new-link="true"
														@onChange="getData"
														@onError="onPdfError"
													></BasePdfUploader>
												</div>
											</div>
											<div class="column"></div>
										</div>
										<div>
											<label class="opit_title req">Опыт</label>
											<template v-if="item.opit && item.opit.length > 0">
												<div class="opit_wrapper"
												     v-for="(opit, index2) in item.opit" :key="index2">
													<div style="text-align: right">
                                                    <span class="delete_icon" @click="deleteOpitItem(index, index2)"
                                                          style="cursor: pointer; display: inline-block;"><i
	                                                    class="far fa-trash-alt"></i></span>
													</div>
													<div class="columns is-gapless">
														<div class="column">
															<div class="field">
																<label class="req">Название проекта</label>
																<input @change="saveData"
																       type="text"
																       v-model="opit.project_name"
																       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
															</div>
														</div>
														<div class="column">
															<div class="field">
																<label class="req">Год реализации</label>
																<input type="text"
																       @change="saveData"
																       v-model="opit.year_realezatii"
																       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
															</div>
														</div>
														<div class="column">
															<div class="field">
																<label class="req">Роль на проекте</label>
																<input @change="saveData"
																       type="text"
																       v-model="opit.role"
																       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
															</div>
														</div>
													</div>
													<div class="columns is-gapless">
														
														<div class="column">
															<div class="field">
																<label for="project_fprk_name" class="req">Ссылка на
																	информацию о проекте</label>
																<input @change="saveData" type="text"
																       v-model="opit.link"
																       style="background-repeat: no-repeat; background-attachment: scroll; background-size: 16px 18px; background-position: 98% 50%; cursor: auto;">
															</div>
														</div>
													</div>
													<div class="field">
														
														<label for="project_fprk_opit_authors" class="req">Сведения
															об
															участии ранее созданных проектов в российских и
															международных
															фестивалях</label>
														<textarea @change="saveData"
														          v-model="opit.description"></textarea>
													</div>
												</div>
											</template>
											
											<p style="margin-bottom: 30px; margin-top: 10px;">
												<button @click.prevent="addOpit(index)" class="button4">ДОБАВИТЬ
													ПРОЕКТ
												</button>
											</p>
										</div>
										
										<div class="field"
										     v-if="item.whois === 'author_scenario' || item.whois === 'author_scenario2' || item.whois === 'regiser' || item.whois === 'regiser2' || item.whois === 'compositor'">
											<label for="project_fprk_opit_authors">Дополнительная информация</label>
											<textarea style="max-width: initial" @change="saveData"
											          v-model="item.addinfo"></textarea>
										</div>
									</div>
									
									<p style="margin-bottom: 30px; margin-top: 10px;">
										<button @click.prevent="addItem" class="button4"
										        style="text-transform: uppercase">добавить участника творческой
											группы
										</button>
									</p>
									<p class="precent">Ваш процент членов творческой группы, местом жительства
										которых
										являются субъекты
										Российской Федерации за исключением г. Москвы, Московской области и г.
										Санкт–Петербурга, Ленинградской области - {{ percent_region }}</p>
								</div>
								
								<div class="hr"></div>
								
								<!--                                <div class="subtitle">ПОДДЕРЖКА ПРОЕКТА</div>-->
								
								<!--                                <BasePdfUploader-->
								<!--                                        :project="project"-->
								<!--                                        :currentProjectId="currentProjectId"-->
								<!--                                        label="Подтверждение подачи Заявки на участие в Конкурсном отборе проектов (п. 4.7.17 Документации Конкурсного отбора проектов) (в формате PDF, макс. 20 мегабайт)"-->
								<!--                                        :value="project.project_data.zayavlenie"-->
								<!--                                        pathToUpload="/project/uploadProjectFprkNew/"-->
								<!--                                        :pathToDelete="'/project/removeProjectPdf/'+project.id+'/zayavlenie/fprk'"-->
								<!--                                        objectKey="zayavlenie"-->
								<!--                                        entityKey="fprk"-->
								<!--                                        @onChange="getData"-->
								<!--                                        @onError="onPdfError"-->
								<!--                                ></BasePdfUploader>-->
								
								<!--                                <div class="hr" style="border-bottom: 1px solid #DB7F1C"></div>-->
								
								<div id="role" style="margin-bottom: 30px;">
									
									<!--                                    <div class="columns">-->
									<!--                                        <div class="column">-->
									<!--                                            <BasePdfUploader-->
									<!--                                                    :project="project"-->
									<!--                                                    :currentProjectId="currentProjectId"-->
									<!--                                                    label="ДОКУМЕНТАЦИЯ конкурсного отбора проектов, посвященных современным региональным трендам, «РОССИЯ – ВЗГЛЯД В БУДУЩЕЕ»"-->
									<!--																										:description="'<p>Скачайте шаблон по <a href=\'/generate_word'+project.id+'\' target=\'_blank\'>ссылке</a>, подпишите его и прикрепите отсканированный и подписанный вариант в формате pdf в это поле</p>'"-->
									<!--                                                    :value="project.project_data.to_sign"-->
									<!--                                                    pathToUpload="/project/uploadProjectFprkNew/"-->
									<!--                                                    :pathToDelete="'/project/removeProjectPdf/'+project.id+'/to_sign/fprk'"-->
									<!--                                                    objectKey="to_sign"-->
									<!--                                                    :is-required="true"-->
									<!--                                                    entityKey="fprk"-->
									<!--                                                    @onChange="getData"-->
									<!--                                                    @onError="onPdfError"-->
									<!--                                            ></BasePdfUploader>-->
									<!--                                        </div>-->
									<!--                                    </div>-->
									
									<div><label class="req">Представленные Участниками на конкурсный отбор проектов
										Проекты
										не
										должны
										иметь
										полученную финансовую поддержку за счет федерального и/или муниципального
										финансирования.</label></div>
									<div class="checkbox__wrapper" style="margin-top: 15px;">
										<input :disabled="project_status !== 'Черновик'" @change="saveData" type="checkbox"
										       id="role_0"
										       value="1" v-model="project.country_town">
										<label style="cursor: pointer" for="role_0">У проекта нет финансовой
											поддержки за счёт
											федерального и/или муниципального финансирования</label>
									</div>
								</div>
								<!--                            <input @change="saveData" type="radio" id="role_1"-->
								<!--                                   value="yes" v-model="project.country_town">-->
								<!--                            <label style="cursor: pointer" for="role_1">У проекта есть финансовая поддержка за счёт-->
								<!--                                федерального и/или муниципального финансирования</label>-->
							</div>
						</div>
					</div>
					<div v-if="tabNum === 2" id="tab2" class="content-tab">
						<div>
							<h2 style="margin-bottom: 30px;">Анкета Участника (организация/ИП) (п. 4.7.1 - 4.7.2,
								4.7.4
								- 4.7.9
								Документации Конкурсного отбора)</h2>
							
							
							<div class="subtitle">ИНФОРМАЦИЯ ОБ ОРГАНИЗАЦИИ</div>
							
							<BaseTextarea
								label="1. Полное наименование организации либо фамилия, имя и отчество (при наличии) Участника - индивидуального предпринимателя"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								:is-required="true"
								v-model="user.user_data.organization_name"
								@onChange="saveUserData"
							></BaseTextarea>
							
							<BaseTextarea
								label="2. Сокращенное наименование организации в соответствии с ЕГРЮЛ (для юридических лиц при наличии)"
								v-model="user.user_data.organization_name_short"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseTextarea>
							
							
							<div class="columns
column-3-fio">
								<div class="column">
									<BaseInput
										label="3. ОГРН/ОГРНИП"
										:is-required="true"
										v-model="user.user_data.ogrn"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
								<div class="column">
									<BaseInput
										label="4. ИНН"
										:is-required="true"
										v-model="user.user_data.inn"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
								<div class="column">
									<!--																		description="<a target='_blank' href='https://disk.yandex.ru/i/fYR26UxVt_XHUg'>Скачать</a>"-->
									<BaseInput
										label="5. КПП (для юридических лиц)"
										:isDescriptionHtml="true"
										v-model="user.user_data.kpp"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
							</div>
							
							<div class="columns columns-2">
								<div class="column">
									<BaseInput
										label="6. Дата регистрации организации/индивидуального предпринимателя"
										v-model="user.user_data.date_register"
										:is-required="true"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
								<div class="column"></div>
							</div>
							
							<div class="columns">
								<div class="column">
									<!--									<BaseTextarea-->
									<!--										label="7. Адрес (местонахождение)/местожительства (для индивидуального предпринимателя)"-->
									<!--										v-model="user.user_data.organization_address"-->
									<!--										:is-required="true"-->
									<!--										:isDataUpdated="isDataUpdating"-->
									<!--										:isFormSubmitted="isSubmitted"-->
									<!--										@onChange="saveUserData"-->
									<!--									></BaseTextarea>-->
									
									<label>7. Адрес юридического лица как в ЕГРЮЛ / адрес места жительства как в паспорте (для индивидуального предпринимателя)</label>
									<BaseLocationCountryRegionCity
										v-model:country="user.user_data.organization_address_country"
										v-model:city="user.user_data.organization_address_city"
										v-model:region="user.user_data.organization_address_region"
										v-model:address="user.user_data.organization_address_address"
										labelCountry="Страна"
										label-city="Город"
										label-region="Регион"
										:show-address="true"
										:is-address-required="true"
										:is-city-required="true"
										:is-country-required="true"
										:is-region-required="true"
										@onChange="saveUserData"
									/>
								</div>
							</div>
							
							
							<div class="columns column-3-fio">
								<div class="column">
									<BaseTextarea
										label="8. Фактическое местонахождение организации/ индивидуального предпринимателя"
										:is-required="true"
										v-model="user.user_data.organization_address_fakt"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseTextarea>
								</div>
								<div class="column">
									<BaseTextarea
										label="9. Адрес для направления организации/индивидуальному предпринимателю юридически значимых сообщений"
										:is-required="true"
										v-model="user.user_data.organization_address_notions"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseTextarea>
								</div>
							
							</div>
							
							<BaseInput
								label="10. Фамилия, имя и отчество (при наличии) руководителя организации"
								v-model="user.user_data.fio_boss"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseInput>
							
							
							<BasePdfUploader
								label="11. Документы, подтверждающие полномочия лица на осуществление действий от имени Участника юридического лица:<br>
1.1. решение о назначении или избрании физического лица на должность:
с подтверждением нотариального удостоверения факта принятия такого решения в обществах с ограниченной ответственностью - если решение датировано после 01.09.2024/до 01.09.2024 и при этом Уставом не предусмотрен иной способ удостоверения.
 в иных случаях, в том числе для юридических лиц других организационно-правовых форм, скан копия должна быть удостоверена уполномоченным лицом Участника.<br>
1.2. скан копия приказа о вступлении физического лица в должность единоличного исполнительного органа (генерального директор/директора и т.п.), в соответствии с которым такое физическое лицо обладает правом действовать от имени заявителя без доверенности)."
								:value="user.user_data.polnomovhiya"
								pathToUpload="/uploadUserDocument"
								:pathToDelete="'/removeUserPdf/polnomovhiya'"
								objectKey="polnomovhiya"
								entityKey="user_documents"
								:is-new-link="true"
								@onChange="getUserData"
								@onError="onPdfError"
							></BasePdfUploader>
							
							
							<p style="font-weight: bold">12. Информация о наличии лиц, имеющих право подписи без доверенности (только для
								организаций)</p>
							<div class="field">
								<div class="checkbox__wrapper">
									<input @change="saveUserData" type="checkbox" id="user_edit_data_accept"
									       v-model="user.user_data.pravo_without">
									<label class="" for="user_edit_data_accept">Следует поставить отметку, если у
										организации-заявителя есть лица, имеющие право подписи без доверенности, кроме
										руководителя. При отстутствии таких лиц отметка не ставится.</label>
								</div>
							</div>
							
							<BaseInput
								label="12.1. Сведения о лице, уполномоченном действовать от имени Участника по доверенности (если применимо)"
								v-model="user.user_data.predstaviteli"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseInput>
							
							<BasePdfUploader
								label="12.2. Доверенность лица, уполномоченного действовать от имени Участника по доверенности (если применимо)"
								:value="user.user_data.doverennost"
								pathToUpload="/uploadUserDocument"
								:pathToDelete="'/removeUserPdf/doverennost'"
								objectKey="doverennost"
								entityKey="user_documents"
								:is-new-link="true"
								@onChange="getUserData"
								@onError="onPdfError"
							></BasePdfUploader>
							

							
							<BaseChoiseSelect
								label="13. Система налогообложения"
								v-model="user.user_data.organization_nalogi"
								:is-required="true"
								:values="[
                                {
                                  'value': 'ОСНО',
                                  'label': 'ОСНО'
                                },
                                {
                                  'value': 'УСН 15%',
                                  'label': 'УСН 15%'
                                },
                                {
                                  'value': 'УСН 6%',
                                  'label': 'УСН 6%'
                                },
															]"
								@onChange="saveUserData"
							/>
							
							<BaseTextarea
								label="14. Банковские
                                        реквизиты:
                                        <div style='font-weight: normal'>Расчетный счет<br>
                                        Банковский идентификационный код (БИК)<br>
                                        Название банка<br>
                                        Корреспондентский счет<br>
                                        Лицевой счет в УФК (при наличии)<br>
                                        Наименование территориального органа Федерального казначейства (при наличии)</div>"
								v-model="user.user_data.organization_rekviziti"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseTextarea>
							
							<div class="hr"></div>
							<div class="subtitle">КОНТАКТНАЯ ИНФОРМАЦИЯ</div>
							
							<div class="column-3-fio columns">
								<div class="column">
									<BaseInput
										label="15. Адрес электронной почты организации/индивидуального предпринимателя"
										v-model="user.user_data.organization_email"
										:is-required="true"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
								<div class="column">
									<BaseInput
										label="16. Контактный телефон"
										v-model="user.user_data.organization_phone"
										:is-required="true"
										:isDataUpdated="isDataUpdating"
										:isFormSubmitted="isSubmitted"
										@onChange="saveUserData"
									></BaseInput>
								</div>
								<div class="column">
								</div>
							</div>
							
							<!--                            <BaseInput-->
							<!--                                    label="15. Система налогообложения (ОСНО, УСН 15%, УСН 6%)"-->
							<!--                                    v-model="user.user_data.organization_nalogi"-->
							<!--                                    :is-required="true"-->
							<!--                                    :isDataUpdated="isDataUpdating"-->
							<!--                                    :isFormSubmitted="isSubmitted"-->
							<!--                                    @onChange="saveUserData"-->
							<!--                            ></BaseInput>-->
							
							
							
							
							
<!--							<div class="hr"></div>-->
							
							
<!--							<p><label class="req">17. Наличие удостоверения национального фильма / планируется ли получение-->
<!--								удостоверения национального фильма</label></p>-->
<!--							<div class="field">-->
<!--								<input @change="saveUserData" type="checkbox" id="user_edit_data_accept"-->
<!--								       v-model="user.user_data.yd_nats">-->
<!--							</div>-->
							
							
							<div class="hr"></div>
							
							<div class="subtitle">ФАЙЛЫ</div>
							
							<div class="columns columns-2">
								<div class="column">
									<BasePdfUploader
										label="17. Копия Устава в действующей редакции"
										:value="user.user_data.ystav_copy"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/ystav_copy'"
										objectKey="ystav_copy"
										entityKey="user_documents"
										:is-new-link="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
								<div class="column">
									<BasePdfUploader
										label="18. Свидетельство о государственной регистрации или Лист записи ЕГРЮЛ/ЕГРИП"
										:value="user.user_data.svidetelstvo"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/svidetelstvo'"
										objectKey="svidetelstvo"
										entityKey="user_documents"
										:is-new-link="true"
										:is-required="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
							</div>
							
							<div class="columns columns-2">
								<div class="column">
									<BasePdfUploader
										label="19. Выписка в электронном виде из единого государственного реестра юридических
лиц или из единого государственного реестра индивидуальных предпринимателей, выданная не
позднее чем за один месяц до подачи Заявки"
										:value="user.user_data.vipiska"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/vipiska'"
										objectKey="vipiska"
										entityKey="user_documents"
										:is-new-link="true"
										:is-required="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
								<div class="column">
									<BasePdfUploader
										label="20. Копия паспорта, разворот с фото и страница с актуальной регистрацией (для индивидуальных предпринимателей)"
										:value="user.user_data.copy_pasport"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/copy_pasport'"
										objectKey="copy_pasport"
										entityKey="user_documents"
										:is-new-link="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
							</div>
							
							<div class="columns columns-2">
								<div class="column">
									<BasePdfUploader
										label="21. Cправка об исполнении налогоплательщиком (плательщиком сбора, плательщиком страховых взносов, налоговым агентом) обязанности по уплате налогов, сборов, страховых взносов, пеней, штрафов, процентов по форме по КНД 1120101"
										:value="user.user_data.spravka"
										description="<p><a href='https://disk.yandex.ru/i/ROtmeK1LvMpNhw' target='_blank'>Ссылка на скачивание</a> (при отсутсвии справки необходимо направить гарантийное письмо)</p>"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/spravka'"
										objectKey="spravka"
										entityKey="user_documents"
										:is-new-link="true"
										:is-required="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
								<div class="column">
									<BasePdfUploader
										label="22. Документ об одобрении крупной сделки – заключения договора создания документального фильма  в случае победы в Конкурсном отборе проектов, если сделка является для заявителя крупной, либо декларация о том, что сделка не является крупной для заявителя и не подлежит одобрению (документы по данному пункту прикрепляются только Участниками в форме ООО, АО, АНО, если законом для них предусмотрено такое одобрение)."
										:value="user.user_data.big_deal"
										description="<p><a href='https://disk.yandex.ru/i/OTQTePyvZEV9zg' target='_blank'>Ссылка на скачивание</a></p>"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/big_deal'"
										objectKey="big_deal"
										entityKey="user_documents"
										:is-new-link="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
							</div>
<!--							columns-2-->
							<div class="columns ">
								<div class="column">
									<BasePdfUploader
										label="23. Документ о том, что сделка по заключению договора создания документального фильма в случае победы в Конкурсном отборе проектов, не является для заявителя сделкой с заинтересованностью (предоставляется заявителями в форме общества с ограниченной ответственностью, акционерного общества, некоммерческой организации)."
										:value="user.user_data.deal_win"
										description="<p><a href='https://disk.yandex.ru/i/OTQTePyvZEV9zg' target='_blank'>Ссылка на скачивание</a></p>"
										pathToUpload="/uploadUserDocument"
										:pathToDelete="'/removeUserPdf/deal_win'"
										objectKey="deal_win"
										entityKey="user_documents"
										:is-new-link="true"
										@onChange="getUserData"
										@onError="onPdfError"
									></BasePdfUploader>
								</div>
<!--								<div class="column">-->
<!--									-->
<!--								</div>-->
							</div>
							
							
							<BaseTextarea
								label="24. Опыт организации (фильмография, сведения о реализации аналогичных проектов, ссылки на информацию и просмотр в сети «Интернет», сведения об участии ранее созданных проектов в российских и международных фестивалях)."
								v-model="user.user_data.organization_opit"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseTextarea>
							
							<BaseTextarea
								label="25. Опыт руководителя (биография и фильмография руководителя, сведения о реализации аналогичных проектов, ссылки на информацию и просмотр в сети «Интернет», сведения об участии ранее созданных проектов в российских и международных фестивалях)"
								v-model="user.user_data.bos_opit"
								:is-required="true"
								:isDataUpdated="isDataUpdating"
								:isFormSubmitted="isSubmitted"
								@onChange="saveUserData"
							></BaseTextarea>
							
							
							<!--																		description="<p><a href='https://docs.yandex.ru/docs/view?url=ya-disk-public%3A%2F%2FvTcBk2nSFAQeyOXNlKQDQEmtLrDjA1Fy046dI8yQkqMfb3DVs9D4nLWstwmNADIJq%2FJ6bpmRyOJonT3VoXnDag%3D%3D&name=Подтверждение%20подачи%20заявки_форма.pdf' target='_blank'>Ссылка на форму</a></p>"-->
							<BasePdfUploader
								:project="project"
								:currentProjectId="currentProjectId"
								:description="'<p><a href=\'/generate_word/'+project.id+'\' target=\'_blank\'>Ссылка на форму</a></p>'"
								label="26. Подтверждение подачи Заявки на участие в Конкурсном отборе проектов (п. 4.7.19 Документации Конкурсного отбора проектов)"
								:value="project.project_data.zayavlenie"
								pathToUpload="/project/uploadProjectFprkNew/"
								:pathToDelete="'/project/removeProjectPdf/'+project.id+'/zayavlenie/fprk'"
								objectKey="zayavlenie"
								:is-required="true"
								entityKey="fprk"
								:is-new-link="true"
								@onChange="getData"
								@onError="onPdfError"
							></BasePdfUploader>
						
						</div>
					</div>
				</div>
			
			</Form>
		
		</div>
		<div v-else style="text-align: center">
			<Spin></Spin>
		</div>
		<Modal
			v-model="isShow"
			:close="closeModal"
		>
			<div class="modal">
				<i @click="closeModal" class="fas fa-times-circle close_button"></i>
				<div class="choise_category">
					<h1>Выберите категорию конкурса {{ competition?.name }}</h1>
					<div v-if="isLoading">
						<div class="lds-default">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</div>
					<div v-else class="categories-container">
						<div v-for="category in competition?.categories" :key="category.id" class="category-card">
							<div class="category-content">
								<div class="category-title">
									<i v-if="category.isProjectInfoSubmitted === '1'" class="fas fa-check-square category-status-icon"></i>
									<span>{{ category.name }}</span>
								</div>
								<div class="category-status">
									<span v-if="category.isProjectInfoSubmitted === '1'" class="status-submitted">Заявка подана</span>
									<span v-else class="status-not-submitted">Заявка не подана</span>
								</div>
							</div>
							<div class="category-action">
								<button
									class="submit-button"
									:class="{'submitted': category.isProjectInfoSubmitted === '1'}"
									@click="makeProjectInfo(category.id, category.isProjectInfoSubmitted)"
								>
									<span v-if="category.isProjectInfoSubmitted === '1'">Заявка подана</span>
									<span v-else>Подать заявку</span>
								</button>
							</div>
						</div>
					
<!--						<p class="category_select"-->
<!--						   :class="category.isProjectInfoSubmitted === '1' ? 'category_select_active' : ''"-->
<!--						   @click="makeProjectInfo(category.id, category.isProjectInfoSubmitted)"-->
<!--						   v-for="category in competition?.categories" :key="category.id"><i-->
<!--							v-if="category.isProjectInfoSubmitted === '1'" style="color: green; margin-right: 10px;"-->
<!--							class="fas fa-check-square"></i> {{ category.name }} <span-->
<!--							v-if="category.isProjectInfoSubmitted === '1'">(Заявка подана)</span></p>-->
					
					
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<style scoped>
.opit_wrapper {
	position: relative;
	margin-bottom: 20px;
	border-radius: 12px;
	padding: 20px;
	background: #FFF;
	box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.12);
}

.columns.is-gapless input[type=text] {
	max-width: 275px;
}

.opit_wrapper input[type=text] {
	max-width: 330px;
}

label.opit_title {
	margin-bottom: 10px;
	display: block;
}

#command {
	margin-bottom: 50px;
}

#command .button2 {
	margin-top: 0;
}

.command_wrapper {
	padding: 20px;
	border-radius: 12px;
	background: #F1EDE7;
	margin-bottom: 35px;
	position: relative;
}

.opit_wrapper {
	margin-bottom: 20px;
}

.opit_wrapper input[type=text] {
	max-width: 330px;
}

p.opit_title {
	font-size: 15px;
	margin-bottom: 10px;
}

.modal {
	display: block;
	width: 80%;
	max-width: 950px;
	padding: 30px;
	box-sizing: border-box;
	background-color: #fff;
	font-size: 20px;
	text-align: center;
	margin: 30px auto 30px;
	position: relative;
}

.lds-default {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
	transform: scale(0.5);
	text-align: center;
}

.lds-default div {
	position: absolute;
	width: 6px;
	height: 6px;
	background: #000;
	border-radius: 50%;
	animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
	animation-delay: 0s;
	top: 37px;
	left: 66px;
}

.lds-default div:nth-child(2) {
	animation-delay: -0.1s;
	top: 22px;
	left: 62px;
}

.lds-default div:nth-child(3) {
	animation-delay: -0.2s;
	top: 11px;
	left: 52px;
}

.lds-default div:nth-child(4) {
	animation-delay: -0.3s;
	top: 7px;
	left: 37px;
}

.lds-default div:nth-child(5) {
	animation-delay: -0.4s;
	top: 11px;
	left: 22px;
}

.lds-default div:nth-child(6) {
	animation-delay: -0.5s;
	top: 22px;
	left: 11px;
}

.lds-default div:nth-child(7) {
	animation-delay: -0.6s;
	top: 37px;
	left: 7px;
}

.lds-default div:nth-child(8) {
	animation-delay: -0.7s;
	top: 52px;
	left: 11px;
}

.lds-default div:nth-child(9) {
	animation-delay: -0.8s;
	top: 62px;
	left: 22px;
}

.lds-default div:nth-child(10) {
	animation-delay: -0.9s;
	top: 66px;
	left: 37px;
}

.lds-default div:nth-child(11) {
	animation-delay: -1s;
	top: 62px;
	left: 52px;
}

.lds-default div:nth-child(12) {
	animation-delay: -1.1s;
	top: 52px;
	left: 62px;
}

@keyframes lds-default {
	0%, 20%, 80%, 100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.5);
	}
}

.vue-universal-modal {
	z-index: 1111;
}

.close_button {
	position: absolute;
	right: 15px;
	top: 10px;
	font-size: 20px;
	cursor: pointer;
}

.category_select:hover {
	color: #F69F22;
	cursor: pointer;
}

#project_form {
	padding: 0;
}

.subtitle {
	color: rgba(34, 34, 34, 0.50);
	font-size: 18px;
	font-weight: 700;
	line-height: 120%;
}

.hr {
	border-bottom: 1px solid #F1EDE7;
	width: calc(100% + 40px);
	position: relative;
	left: -20px;
	margin-top: 20px;
	margin-bottom: 20px;
}

.hr2 {
	border-bottom: 1px solid rgba(62, 67, 80, 0.2);
	margin-top: 20px;
	margin-bottom: 20px;
	width: calc(100% + 40px);
	position: relative;
	left: -20px;
}

.command_wrapper input[type="checkbox"] + *::before {
	background: #fff;
	margin-top: -3px;
}

.command_wrapper select {
	background: #fff;
}

.column-3-fio .column:not(:first-child) {
	padding-left: 20px;
}

.delete_icon {
	position: absolute;
	top: 36px;
	right: 20px;
}

.delete_icon i {
	color: #FF8400;
	font-size: 18px;
}

.precent {
	font-size: 15px;
}

.current_status {
	display: inline-block;
	border-radius: 8px;
	background: #F1EDE7;
	padding: 15px;
	margin-bottom: 0 !important;
}

.current_status .current_status__text {
	color: rgba(34, 34, 34, 0.50);
}

.current_status__value {
	color: #4BD258;
}

.button6:hover {
	color: #fff;
}

.bold_label:deep label {
	font-weight: bold;
}

.bold_label {
	margin-bottom: 30px;
}

.columns.column-3-fio {
	align-items: baseline;
}

#project_zhanr .checkbox__wrapper {
	margin-bottom: 7px;
}

.content-tab :deep(label):not(.checkbox__wrapper label) {
	font-weight: bold;
}

.categories-container {
	margin-top: 20px;
}

.category-card {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	margin-bottom: 15px;
	border-radius: 8px;
	background: #F1EDE7;
	transition: all 0.3s ease;
}

.category-card:hover {
	background: #e9e4db;
}

.category-content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
}

.category-title {
	display: flex;
	align-items: center;
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 5px;
}

.category-status-icon {
	color: green;
	margin-right: 10px;
	font-size: 18px;
}

.category-status {
	font-size: 14px;
}

.status-submitted {
	color: #4BD258;
}

.status-not-submitted {
	color: #888;
}

.category-action {
	margin-left: 20px;
}

.submit-button {
	background-color: #F69F22;
	color: #fff;
	border: none;
	border-radius: 6px;
	padding: 10px 20px;
	cursor: pointer;
	font-weight: bold;
	transition: all 0.3s ease;
}

.submit-button:hover {
	background-color: #e08b11;
}

.submit-button.submitted {
	background-color: #4BD258;
	cursor: default;
}

.submit-button.submitted:hover {
	background-color: #4BD258;
}

/* Исправление заголовка */
h1 {
	font-size: 22px;
	margin-bottom: 20px;
	color: #222;
}

@media (max-width: 1000px) {
	#project_zhanr .checkbox__wrapper {
		margin-bottom: 20px;
	}
}
</style>
